import { getInfo } from "@/api/login";

const permission = {
  state: {
    userInfo: "", //用户信息
    userMenu: "" //用于特定路由
  },
  mutations: {
    setUser: (state, info) => {
      //建立用户信息
      state.userInfo = info.user;
      state.userMenu = info.menu;
    },
    removeUser: state => {
      //删除用户信息
      state.userInfo = "";
    }
  },
  actions: {
    // 获取用户信息
    getUser({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(res => {
            commit("setUser", res.data);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default permission;
